import { useCallback, useEffect, useRef, useState } from 'react'

import { useLazyQuery } from '@apollo/client'

import { DATAPOINT_DETAIL_QUERY } from 'services/datapoints'

export const useDatapointHover = (props) => {
  const { delay = 2000 } = props || {}
  const timer = useRef()
  const [hoveredElement, setHoveredElement] = useState(null)
  const [datapointName, setDatapointName] = useState(null)
  const [getDetails, { data: detail }] = useLazyQuery(DATAPOINT_DETAIL_QUERY)

  useEffect(() => {
    return () => clearTimeout(timer.current)
  }, [])

  const onDatapointHover = useCallback(
    (e, datapoint) => {
      if (datapoint) {
        getDetails({
          variables: { datapoint: { id: datapoint?.id } },
          skip: !datapoint?.id,
        })
      }
      setHoveredElement(datapoint?.id ? e.target : null)
      setDatapointName(datapoint?.name)

      if (!datapoint) {
        clearTimeout(timer.current)
      } else {
        if (delay > 0 && datapoint?.id) {
          timer.current = setTimeout(() => {
            setHoveredElement(null)
          }, delay)
        }
      }
    },
    [delay, getDetails]
  )
  return {
    detail: detail?.datapoint || { namedReferences: {}, name: datapointName },
    hoveredElement,
    onDatapointHover,
  }
}
